import { render, staticRenderFns } from "./WorkerCategories.vue?vue&type=template&id=284235f4&scoped=true"
import script from "./WorkerCategories.vue?vue&type=script&lang=js"
export * from "./WorkerCategories.vue?vue&type=script&lang=js"
import style0 from "./WorkerCategories.vue?vue&type=style&index=0&id=284235f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284235f4",
  null
  
)

export default component.exports